import { createElement, forwardRef } from 'react';
import { OmitStrict } from '../../utility-types';
import { BaseSplitButton, BaseSplitButtonProps } from './__internal__/BaseSplitButton';

export interface SplitButtonProps
  extends OmitStrict<
    BaseSplitButtonProps,
    'ariaCurrent' | 'ariaRoleDescription' | 'buttonStyle' | 'buttonClassName'
  > {}

export const SplitButton = forwardRef<HTMLDivElement, SplitButtonProps>(function SplitButton(
  props,
  ref
) {
  return <BaseSplitButton {...props} ref={ref} />;
});
